import axios from 'axios';

import { refreshToken } from '../actions/authActions';
import store from '../store';

const auth = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    withCredentials: true
});

let isRefreshing = false; // To prevent multiple refresh calls
let failedQueue = []; // Queue to store failed requests while refreshing token

const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });

    failedQueue = [];
};

// Add Axios interceptor
auth.interceptors.response.use(
    (response) => {
        // If the response is successful, return it as-is
        return response;
    },
    async (error) => {
        const originalRequest = error.config;

        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            if (isRefreshing) {
                // If a refresh request is already in progress, queue the current request
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                })
                    .then((token) => {
                        originalRequest.headers['Authorization'] = `Bearer ${token}`;
                        return axios(originalRequest);
                    })
                    .catch((err) => Promise.reject(err));
            }

            originalRequest._retry = true; // Mark the request as retried
            isRefreshing = true;

            try {
                // Use refreshToken action
                const response = await store.dispatch(refreshToken());
                const newToken = response?.data?.access_token;

                // Retry all failed requests
                processQueue(null, newToken);

                // Update the token in the headers and retry the original request
                originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
                return axios(originalRequest);
            } catch (refreshError) {
                processQueue(refreshError, null); // Reject all queued requests
                return Promise.reject(refreshError); // Handle token refresh failure
            } finally {
                isRefreshing = false;
            }
        }

        // If the error is not 401, reject the promise
        return Promise.reject(error);
    }
);


export default auth